import reducer, { KansatsuKirokuSubdivState } from "./reducers";
import * as kansatsuKirokuSubdivOperations from "./operations";
export {
  kansatsuKirokuSubdivOperations,
  KansatsuKirokuSubdivState
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/kansatsuKirokuSubdiv/index.ts